import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetChatChannelsQuery } from '../../data/queries/get-chat-channels.query'
import { GetChatTotalsQuery } from '../../data/queries/get-chat-totals.query'
import { type ChatChannelEntity, type ChatTotalsEntity } from '../../data/entities/chat.entity'
import { CombinedChatToResponseMapper } from '../mappers/chat.mappers'
import { type ChatResponse } from '../models/chat'

export interface GetChatParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: string
  sortOrder: string
  organization: string
}

export class GetChatInteractor {
  private readonly mapper = new CombinedChatToResponseMapper()

  constructor(
    private readonly getChatChannels: GetInteractor<ChatChannelEntity[]>,
    private readonly getChatTotals: GetInteractor<ChatTotalsEntity>
  ) {}

  public async execute(params: GetChatParams): Promise<ChatResponse> {
    const [channelsResult, totalsResult] = await Promise.all([
      this.getChatChannels.execute(
        new GetChatChannelsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.sortBy,
          params.sortOrder,
          params.organization
        )
      ),
      this.getChatTotals.execute(
        new GetChatTotalsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.organization
        )
      )
    ])

    return this.mapper.map({
      channels: channelsResult,
      totals: totalsResult
    })
  }
}
